import {find} from 'lodash';
import {observable, computed, action, autorun} from "mobx";

import {event} from '../utilities/withAnalytics';
import TEMPLATES from '../utilities/templates';

export default class TemplateStore {
  constructor(rootStore){
    this._rootStore = rootStore;
    this.templateIdWatcher = autorun(() => {
      if (!this._rootStore.personaStore.body) return;
      const template_id = this._rootStore.personaStore.body.template_id;
      if (template_id) {
        this.template_id = template_id;
      }
    });
  }
  @observable template_id = 0;
  @observable templateSelectorVisible = false;
  templates = TEMPLATES;

  @computed
  get selectedTemplate() {
    return find(this.templates, {'_id': this.template_id});
  }

  @computed
  get defaultTemplate() {
    return this.templates[0];
  }

  // I am naming this selectATemplate because for the life of me I cannot figure out why
  // selectTemplate is undefined
  @action.bound
  selectATemplate(id) {
    const template = this.getTemplate(id); // Only getting template here to pass template info
    event('Template Selector', 'Select', template.occupation ? template.occupation : 'Blank');
    this.template_id = id;
  }

  @action.bound
  hideTemplateSelector() {
    this.templateSelectorVisible = false;
  }

  @action.bound
  showTemplateSelector() {
    this.templateSelectorVisible = true;
  }

  getTemplate(id) {
    return find(this.templates, {'_id': id});
  }

}



// WEBPACK FOOTER //
// ./client/modules/TemplateStore.js